// extracted by mini-css-extract-plugin
export default {"listContainer":"styles_listContainer__j6Sa6","list":"styles_list__rrzxf"};